import React, { useEffect, useState } from 'react'

function ProductLayout({filterProductsLength,setGridLayoutCss}) {

    const [gridLayout, setGridLayout] = useState('two-product');


    useEffect(() => {
        let gridClass;
        switch (gridLayout) {
          case 'one-product':
            gridClass = 'grid-cols-1';
            break;
          case 'two-product':
            gridClass = 'grid-cols-2';
            break;
          case 'four-product':
            gridClass = 'grid-cols-4';
            break;
          default:
            gridClass = 'grid-cols-2';
        }
        setGridLayoutCss(gridClass); 
      }, [gridLayout, setGridLayoutCss]);
    
      useEffect(() => {
        
        const handleResize = () => {
          if (window.innerWidth >= 768) {
            setGridLayout('four-product');
          }else if(window.innerWidth <= 400){
            setGridLayout('one-product');
          } else {
            setGridLayout('two-product');
          }
        };
        // Initial call to set the layout based on the initial window width
        handleResize();
        // Add event listener for window resize
        window.addEventListener('resize', handleResize);
        // Cleanup the event listener on component unmount
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

  return (
    <div className="flex justify-between items-center px-6 p-4 border-b-[1px] product-view-container w-full container">
    <div className="font-primaryFont all-products-length">
        <span className="font-[580] text-sm tracking-wider">{filterProductsLength} Products</span>
    </div>
    <div className="flex justify-between items-center product-view-filter cursor-pointer">
    <div
className={`flex p-2 border one-product `}
onClick={() => setGridLayout('one-product')}
>
            <div className={` w-[20px] h-[20px] box ${gridLayout === 'one-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
        </div>
        <div
className={`flex justify-between items-center gap-1 p-2 border two-product `}
onClick={() => setGridLayout('two-product')}
>                <div className={` w-[5px] h-[20px] box ${gridLayout === 'two-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
        <div className={` w-[5px] h-[20px] box ${gridLayout === 'two-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
        </div>
        <div
className={`flex justify-between items-center gap-1 p-2 border four-product `}
onClick={() => setGridLayout('four-product')}
>         <div className={` w-[5px] h-[20px] box ${gridLayout === 'four-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
        <div className={` w-[5px] h-[20px] box ${gridLayout === 'four-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
        <div className={` w-[5px] h-[20px] box ${gridLayout === 'four-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
        <div className={` w-[5px] h-[20px] box ${gridLayout === 'four-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
        </div>
    </div>
</div>
  )
}

export default ProductLayout